module.exports = __webpack_public_path__ + "static/img/guanfang.e30f4ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/tabbar/guanfang.png
// module id = gtQ6
// module chunks = 28